import { render } from "./Wizard.vue?vue&type=template&id=3a514422"
import script from "./Wizard.vue?vue&type=script&lang=js"
export * from "./Wizard.vue?vue&type=script&lang=js"

import "./Wizard.vue?vue&type=style&index=0&id=3a514422&lang=scss"
script.render = render

export default script